module.exports = __webpack_public_path__ + "static/media/deliveryActive.9e1932e3.svg";